import {
    TextField,
    Select,
    MenuItem,
    Grid,
} from '@material-ui/core';
import AutoComplete from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';
import { TimeUnit } from '../../../../Enums';
import { getTimeUnitLabel } from '../../../../Enums/Helpers/LabellingHelper';
import { noneTemplateId } from '../../../store/setup';
import InputTitle from './InputTitle';

/**
 * @param {import('@material-ui/core').TextFieldProps} props
 */
const TimeValueInput = (props) => (
    <TextField
        type="number"
        variant="outlined"
        className="sue-textfield-time-number remove-gray-space"
        InputProps={{
            inputProps: { min: 0 },
        }}
        {...props}
    />
);

/**
 * @param {import('@material-ui/core').SelectProps} props
 */
const TimeUnitSelect = (props) => (
    <Select
        MenuProps={{
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            },
            transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            },
            getContentAnchorEl: null,
        }}
        variant="outlined"
        className="sue-select-time-unit remove-gray-space"
        {...props}
    >
        <MenuItem value={TimeUnit.Hour}>{getTimeUnitLabel(TimeUnit.Hour)}</MenuItem>
        <MenuItem value={TimeUnit.Day}>{getTimeUnitLabel(TimeUnit.Day)}</MenuItem>
    </Select>
);

/**
 * @param {{
 *  placeholderLabel?: string;
 *  label: string;
 *  id: string;
 *  genericNotificationTemplates: AdminAppData.INotificationTemplate[];
 *  selectedNotif: Setup.INotificationTemplate;
 *  handleUpdateNotification: Function;
 *  handleUpdateTimeValue: Function;
 *  handleUpdateTimeUnit: Function;
 * }} props
 */
function TimedNotificationSelect(props) {
    const {
        placeholderLabel = '',
        label,
        id,
        genericNotificationTemplates,
        selectedNotif,
        handleUpdateNotification,
        handleUpdateTimeValue,
        handleUpdateTimeUnit,
    } = props;
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'common' });
    const isNoneSelected = () => selectedNotif.templateId === noneTemplateId;
    const getNotificationLength = () => (selectedNotif.templateId === noneTemplateId ? 12 : 8);
    const getOptionLabel = (option) => (option.id === noneTemplateId ? t('none') : option.name);

    return (
        <div>
            <InputTitle>{label}</InputTitle>
            <Grid
                container
                justifyContent="space-between"
            >
                <Grid
                    item
                    xs={getNotificationLength()}
                >
                    <AutoComplete
                        id={id}
                        value={genericNotificationTemplates.find((x) => x.id === selectedNotif.templateId)}
                        options={genericNotificationTemplates}
                        onChange={(_event, optionSelected) => handleUpdateNotification(optionSelected.id)}
                        className="sue-autocomplete-full-width"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder={placeholderLabel}
                            />
                        )}
                        getOptionLabel={getOptionLabel}
                        includeInputInList
                        disableClearable
                    />
                </Grid>
                {
                    !isNoneSelected()
                    && (
                        <>
                            <Grid
                                item
                                xs={1}
                            >
                                <TimeValueInput
                                    value={selectedNotif?.timeValue}
                                    onChange={
                                        (/** @type {React.ChangeEvent} */ event) =>
                                            handleUpdateTimeValue(event.target.value)
                                    }
                                />
                            </Grid>
                            <Grid
                                item
                                xs={2}
                            >
                                <TimeUnitSelect
                                    value={selectedNotif?.timeUnit}
                                    className="sue-select-full-width"
                                    onChange={
                                        (/** @type {React.ChangeEvent} */ event) =>
                                            handleUpdateTimeUnit(event.target.value)
                                    }
                                />
                            </Grid>
                        </>
                    )
                }
            </Grid>
        </div>
    );
}

export default TimedNotificationSelect;
